import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import HistoryParametersView from './HistoryParametersView';
import {
  getDeviceDocumentById,
  clearDeviceDocument,
  downloadDeviceDocument,
  clearDocumentFilter,
} from '../../actions/documents';

class HistoryParameters extends React.Component {
  getFilter = deviceDocument => {
    let filter = {};
    switch (deviceDocument.get('deviceType')) {
      case 'softener':
      case 'charlie':
      case 'simplex':
        filter = this.props.documentSoftenerFilter;
        break;
      case 'superior':
        filter = this.props.documentSuperiorFilter;
        break;
      default:
        break;
    }
    return filter;
  };

  componentWillMount() {
    const documentValue = this.props.deviceDocument;
    if (
      typeof documentValue !== 'undefined' &&
      documentValue.get('serial') !== null
    ) {
      this.props.getDeviceDocumentById(
        documentValue.get('serial'),
        documentValue.get('documentName'),
        {},
        1,
        10000,
      );
    }
  }

  componentWillUpdate(newProps) {
    const isUpdatedDocument =
      newProps.deviceDocument.get('serial') !==
      this.props.deviceDocument.get('serial');
    if (
      isUpdatedDocument &&
      newProps.deviceDocument.get('serial') !== null &&
      +newProps.deviceDocument.get('documentType') === 2
    ) {
      this.props.getDeviceDocumentById(
        newProps.deviceDocument.get('serial'),
        newProps.deviceDocument.get('documentName'),
        {},
        1,
        10000,
      );
    }
    return true;
  }

  componentWillUnmount() {
    const deviceDocument = this.props.deviceDocument;
    this.props.clearDeviceDocument();
    this.props.clearDocumentFilter(
      'parameters',
      deviceDocument.get('deviceType'),
    );
  }

  onSavePDF = () => {
    const deviceDocument = this.props.deviceDocument;
    const filter = this.getFilter(deviceDocument);
    this.props.downloadDeviceDocument(
      deviceDocument.get('serial'),
      deviceDocument.get('documentName'),
      JSON.stringify(filter),
    );
  };

  onClearFilter = () => {
    const deviceDocument = this.props.deviceDocument;
    this.props.clearDocumentFilter(
      'parameters',
      deviceDocument.get('deviceType'),
    );
  };

  closePopup = () => {
    const deviceDocument = this.props.deviceDocument;
    this.props.clearDeviceDocument();
    this.props.clearDocumentFilter('events', deviceDocument.get('deviceType'));
  };

  render() {
    return (
      <HistoryParametersView
        deviceDocument={this.props.deviceDocument}
        documentSoftenerFilter={this.props.documentSoftenerFilter}
        documentSuperiorFilter={this.props.documentSuperiorFilter}
        downloadDeviceDocument={this.props.downloadDeviceDocument}
        deviceDocumentPaging={this.props.deviceDocumentPaging}
        onClose={this.closePopup}
        onSavePDF={this.onSavePDF}
        onClearFilter={this.onClearFilter}
      />
    );
  }
}

const mapState = state => ({
  deviceDocument: state.deviceDocument,
  deviceDocumentPaging: state.deviceDocumentPaging,
  documentSoftenerFilter: state.softenerParametersFilter,
  documentSuperiorFilter: state.superiorParametersFilter,
});

const mapDispatch = dispatch => {
  return {
    getDeviceDocumentById: (serial, documentId, filteData, page, pageSize) =>
      dispatch(getDeviceDocumentById(serial, documentId, filteData, page, pageSize)),
    clearDeviceDocument: () => dispatch(clearDeviceDocument()),
    downloadDeviceDocument: (serial, documentId, filter) => 
      dispatch(downloadDeviceDocument(serial, documentId, filter)),
    clearDocumentFilter: (deviceType, documentType) => 
      dispatch(clearDocumentFilter(deviceType, documentType)),
  };
};

HistoryParameters.propTypes = {
  getDeviceDocumentById: PropTypes.func.isRequired,
  downloadDeviceDocument: PropTypes.func.isRequired,
  clearDocumentFilter: PropTypes.func.isRequired,
  clearDeviceDocument: PropTypes.func.isRequired,
  documentSoftenerFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  documentSuperiorFilter: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocument: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

export default connect(mapState, mapDispatch)(HistoryParameters);


// WEBPACK FOOTER //
// ./src/components/HistoryParameters/HistoryParameters.js